/**
 * OWNER CONTROLS' two confirmations, phone chrome.
 * `design/GT Mobile Crew.dc.html` — the transfer and delete sheets.
 *
 * Bodies shared with desktop (`components/OwnerConfirm.tsx`); this is the Sheet
 * wrapper. The phone's delete subhead is just `CANNOT BE UNDONE` where desktop
 * names the crew — the mirrors differ, and both are kept as drawn.
 */

import { Sheet } from '../components/Sheet.tsx';
import { DeleteCrewBody, TransferBody } from '../components/OwnerConfirm.tsx';
import { useQd } from '../store/index.ts';
import { ownerVM } from '../store/selectors.ts';

const M = { bodyFs: '10.5px', fieldFs: '12px', pad: '15px 14px 20px', gap: '13px' };

export default function OwnerSheet(): JSX.Element | null {
  const s = useQd();
  const v = ownerVM(s);
  if (!v.modal) return null;

  const transfer = v.modal === 'transfer';
  return (
    <Sheet
      label={transfer ? 'Transfer ownership sheet' : 'Delete crew sheet'}
      maxHeight="90vh"
      onClose={s.closeOwn}
      header={{
        title: transfer ? 'HAND OVER THE PARTY' : 'DISBAND PARTY',
        titleClr: transfer ? 'var(--gt-text)' : 'var(--acc2)',
        titleFs: '8.5px',
      }}
    >
      {transfer ? <TransferBody m={M} /> : <DeleteCrewBody m={M} />}
    </Sheet>
  );
}
